import { useEffect, useRef } from "react";

type Props = {
  step: string;
  stepClassName?: string;
  handleClicked?: $TSFixMeFunction;
};

function Step({ step, stepClassName, handleClicked }: Props) {
  const ref = useRef(null);

  useEffect(() => {
    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
    if (ref.current.scrollIntoView && stepClassName === " is-current")
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [stepClassName]);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li
      ref={ref}
      onKeyDown={handleClicked}
      onClick={handleClicked}
      className={`c-process-item${stepClassName}`}
    >
      <div className="c-process-title-wrapper">
        <span className="c-process-title">{step}</span>
      </div>
    </li>
  );
}

export default Step;
